export const ApiRoutes = {
    auth: {
        signIn: "/token/backoffice",
        refresh: "/token/refresh",
        logout: "/logout",
    },
    offers: {
        root: "/api/v1/offersManagement/offers",
        offer: "/api/v1/offersManagement/offers/{offerId}",
        goals: "/api/v1/offersManagement/{offerId}/goals",
        challenges: "/api/v1/offersManagement/{offerId}/challenges",
        publish: "/api/v1/offersManagement/publish/{offerId}",
        archive: "/api/v1/offersManagement/archive/{offerId}",
        copyOffer: "/api/v1/offersManagement/copyOffer",
        copyFullOffer: "/api/v1/offersManagement/{offerId}/copyOffer",
        copyGoals: "/api/v1/offersManagement/copyGoals",
        uploadIdfaCsv: "/api/v1/offersManagement/uploadIdfaCsv",
        stats: "/api/v1/offersManagement/stats",
        validateOffer: "/api/v1/offersManagement/{offerId}/validate",        
        activateOffer: "/api/v1/offersManagement/{offerId}/activate",
        deactivateOffer: "/api/v1/offersManagement/{offerId}/deactivate",
        serverConfigs: "/api/v1/serverConfigs",
    },
    gameCategories: {
        root: "/api/v1/gameCategories",
    },
    genres: {
        root: "/api/v1/offerGenres",
    },
    targetGroups: {
        root: "/api/v1/targetGroupsManagement",
        targetGroup: "/api/v1/targetGroupsManagement/{groupId}",
    },
    achievements: {
        root: "/api/v1/achievementsManagement",
        achievement: "/api/v1/achievementsManagement/{achievementId}",
    },
    quests: {
        root: "/api/v1/questsManagement/quests",
        quest: "/api/v1/questsManagement/quests/{questId}",
        schedules: {
            root: "/api/v1/questsManagement/schedules",
            schedule: "/api/v1/questsManagement/schedule/{scheduleId}",
        },
        templates: {
            root: "/api/v1/questsManagement/templates",
            template: "/api/v1/questsManagement/templates/{templateId}",
        },
    },
    users: {
        root: "/api/v1/usersManagement",
        reapproveConversion: "/api/v1/conversionsManagement/{conversionId}/requestRecheck",
        forceApproveConversion: "/api/v1/conversionsManagement/forceApprove",
        balanceCorrection: "/api/v1/userBalanceManagement/correction",
        banUser: "/api/v1/usersManagement/ban",
        unbanUser: "/api/v1/usersManagement/unban",
    },
    spinWheel: {
        root: "/api/v1/spinWheelManagement",
    },
    banners: {
        root: "/api/v1/bannersManagement",
    },
    abTests: {
        root: "/api/v1/abTestsManagement",
        abTest: "/api/v1/abTestsManagement/{abTestId}",
    },
    clients: {
        root: "/api/v1/clientsManagement",
        client: "/api/v1/clientsManagement/{clientId}",
    },
};
